import { useMemo, useState } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import { useLang } from '../../../../../../hooks/use-lang';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';
import { LangType } from '../../../../../../helpers/lang';
import { useFetchDashboardData } from '../../use-fetch-dashboard';

interface DataType {
  dishes: LangType[];
  percentage: number[];
}

export const useMostOrderedDishes = (): ChartProps => {
  const { t, getLocale } = useLang();
  const [sectionIds, setSectionIds] = useState<string[]>([]);

  const { list } = useFetchDashboardData(['top_10_dishes'], {
    section_ids: sectionIds.length ? sectionIds : undefined,
  });

  const data = list?.top_10_dishes as DataType;

  const chartData: ReactApexChartProps = useMemo(() => {
    const categories = data?.dishes.map((dish) => getLocale(dish)) || [];
    const series = data?.percentage || [];

    return {
      series: series.length ? [{ data: series }] : undefined,
      options: {
        chart: {
          type: 'bar',
          width: '100%',
          toolbar: {
            show: false,
          },
        },
        grid: {
          show: false,
          padding: {
            left: -14,
            right: -14,
            bottom: -14,
            top: 10,
          },
        },
        plotOptions: {
          bar: {
            barHeight: 8,
            borderRadius: 4,
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'bottom',
              maxItems: 10,
            },
          },
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          style: {
            colors: ['#000'],
            fontSize: '14px',
            fontWeight: 'normal',
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ' (' + val + '%)';
          },
          offsetY: -16,
          offsetX: -10,
        },
        stroke: {
          width: 0,
          colors: ['#fff'],
        },
        xaxis: {
          categories,
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          labels: {
            show: false,
          },
        },
        yaxis: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        annotations: {
          texts: [
            {
              text: t('Название позиции'),
              fontSize: 12,
              x: 0,
              y: 20,
              textAnchor: 'start',
              borderColor: 'transparent',
              foreColor: '#828282',
              fontWeight: 400,
            },
          ],
        },
        colors: ['#962DFF'],
      },
    };
  }, [getLocale, t, data]);

  return {
    series: chartData.series,
    options: chartData.options,
    label: 'Топ-10 позиций',
    subLabel:
      'Горизонтальная диаграмма отражает процент популярности 10 самых заказываемых позиций, упрощая оценку предпочтений гостей',
    type: 'bar',
    filters: {
      sections: {
        onChangeSectionIds: setSectionIds,
        sectionIds,
      },
    },
  };
};
